import { getFilesFromDirectory, fileToBase64 } from '../utils/files';
import type { LocalImage } from './offlineCompoundQueue';

/**
 * Capture all images from OPFS directories and serialize them to base64
 * for offline storage in IndexedDB.
 */
export async function captureLocalImages(
  directories: string[]
): Promise<LocalImage[]> {
  const images: LocalImage[] = [];

  for (const dir of directories) {
    try {
      const files = await getFilesFromDirectory(dir);
      for (const { file } of files) {
        const base64 = await fileToBase64(file);
        images.push({
          fileName: file.name,
          directory: dir,
          base64Data: base64,
          mimeType: file.type || 'image/jpeg',
        });
      }
    } catch {
      // Directory may not exist if no images were taken — that's fine
      continue;
    }
  }

  return images;
}
